/* eslint-disable require-jsdoc */
import {Brick, registerBrick, Transaction, File as OFile, CloudObject} from 'olympe';
import {tagToDisplayER} from '../tagTransforms';
import {PurchaseRequest} from '../../models/PurchaseRequest';
import * as ExcelJS from 'exceljs';
import {excelHeaderFields} from '../constants';
import {itemsExportPR} from '../itemsExportPR';
/**
 * Brick responsible to export PRs to an Excel file
 */
export default class ExportPRsToExcelFile extends Brick {
    /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {{json: string, tag: string, total: number}[]} pRArray
   * @param {string} excelFileName
   * @param {function()} forwardEvent
   * @param {function(File)} setFile
   * @param {function(string)} setFileName
   */
    update($, [pRArray, excelFileName], [forwardEvent, setFile, setFileName]) {
        const manipulatedPRs = pRArray.map( (pr) => ({json: pr.json, tag: pr.tag}));

        const excelFilePath = excelFileName.endsWith('.xlsx') ?
            excelFileName :
            excelFileName + '.xlsx';

        // 0191e158aa957d476b18 is the tag of the Excel template
        CloudObject.get('0191e158aa957d476b18').getContentAsBinary(
            async (binary) => {
                try {
                    const workbook = new ExcelJS.Workbook();

                    await workbook.xlsx.load(binary, {useStyles: true});

                    const headerSheet = workbook.getWorksheet('Header');
                    const itemsSheet = workbook.getWorksheet('Items');

                    // Header sheet data
                    const uniquePRs = new Map();

                    manipulatedPRs.forEach((pr) => {
                        const prData = JSON.parse(pr.json);
                        const EPRId = 'EPR-' + (prData.EPRId || tagToDisplayER(pr.tag));
                        if (!uniquePRs.has(EPRId)) {
                            uniquePRs.set(EPRId, prData);
                        }
                    });

                    let rowNumber = 3;
                    uniquePRs.forEach((prData, EPRId) => {
                        const row = headerSheet.getRow(rowNumber);
                        excelHeaderFields.forEach((field) => {
                            const cell = row.getCell(field.column);
                            let value = field.value(prData, EPRId, excelFileName);

                            if (value === null || value === undefined) {
                                value = '';
                            } else {
                                value = value.toString();
                            }

                            cell.value = value;
                        });
                        row.commit();
                        rowNumber++;
                    });

                    // items sheet part
                    rowNumber = 3;
                    uniquePRs.forEach((prData, EPRId)=>{
                        const itemsData = itemsExportPR(new PurchaseRequest(JSON.stringify(prData)), EPRId);
                        itemsData.forEach((rowData) => {
                            const row = itemsSheet.getRow(rowNumber);
                            rowData.forEach((value, colIndex) => {
                                row.getCell(colIndex + 1).value = value;
                            });
                            row.commit();
                            rowNumber++;
                        });
                    });

                    const modifiedBinary = await workbook.xlsx.writeBuffer();

                    const transaction = new Transaction(false);
                    const fileTag = transaction.create(OFile);
                    transaction.persist(fileTag, false);
                    const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    OFile.setContent(transaction, fileTag, excelFilePath, modifiedBinary, mimeType);

                    transaction
                        .execute()
                        .then(() => {
                            CloudObject.get(fileTag).saveAs(excelFilePath);
                            forwardEvent();
                        })
                        .catch((message) => console.error('Transaction Error:', message));
                } catch (error) {
                    console.error('Error processing the Excel file:', error);
                }
            },
            (error) => console.error('Error fetching binary data:', error),
        );
    }
}

registerBrick('0181aaeca35ae2c7f535', ExportPRsToExcelFile);
